import { Injectable } from '@angular/core';
import { Portal } from 'src/models/portals';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class PortalsService extends GenericObjectsService<Portal> {
  protected baseUrl = '/portals';

  update(
    id: string,
    payload: Omit<Partial<Portal>, 'settings'> & { settings?: Partial<Portal['settings']> },
  ): Promise<Portal> {
    return this.apiService.patchPromise<Portal>(`${this.baseUrl}/${id}`, payload);
  }

  generateEmbedSecret(portalId: string): Promise<{ secret: string }> {
    return this.apiService.postPromise<{ secret: string }>(`${this.baseUrl}/${portalId}/embed-secret`, {});
  }

  revokeEmbedSecret(portalId: string): Promise<void> {
    return this.apiService.deletePromise<void>(`${this.baseUrl}/${portalId}/embed-secret`);
  }
}
